import React, { Fragment } from 'react'

import FriendLabel, { YourLabel } from './FriendLabel'
import OrderStatusSidebar from '../common/OrderStatusSidebar'
import classnames from 'classnames'

export const UnderFiveFriends = ({ friendsCount }) => (
  <div className="row center-xs piggybankNeedFriends">
    Invite {friendsCount === 0 ? 5 : 5 - friendsCount} more{' '}
    {friendsCount === 4 ? 'friend' : 'friends'} to start earning.
  </div>
)

export const OverFiveFriendsNoOrder = ({ friendsOrderCount, friendsCount }) => (
  <div className="row center-xs">
    <FriendCircles
      friendsOrderCount={friendsOrderCount}
      classNames={{ youLabelEmpty: true }}
    />
    {friendsCount >= 5 && (
      <div className="col-xs-12 center-xs piggybankFriends">
        {friendsOrderCount.length >= 5
          ? 'Almost there! Place your order to earn $1.'
          : `You and ${5 - friendsOrderCount.length} more ${
              friendsOrderCount.length === 4 ? 'friend needs' : 'friends need'
            } to order.`}
      </div>
    )}
  </div>
)

export const OverFiveFriendsWithOrder = ({
  friendsOrderCount,
  friendsCount
}) => (
  <div className="row center-xs">
    <FriendCircles
      friendsOrderCount={friendsOrderCount}
      classNames={{ youLabelColored: true }}
    />
    {friendsCount >= 5 && friendsOrderCount.length < 5 ? (
      <div className="col-xs-12 center-xs piggybankFriends">
        {5 - friendsOrderCount.length} more{' '}
        {friendsOrderCount.length === 4 ? 'friend needs' : 'friends need'} to
        order.
      </div>
    ) : (
      friendsCount >= 5 && (
        <div className="col-xs-12 center-xs piggybankFriends">
          You will receive $1 when your food arrives.
        </div>
      )
    )}
  </div>
)

export const PiggyBankSuccess = ({ friendsOrderCount }) => (
  <div className="row center-xs">
    <FriendCircles
      friendsOrderCount={friendsOrderCount}
      classNames={{ youLabelColored: true }}
      piggyBankSuccess
    />
    <div className="col-xs-12 center-xs piggybankFriends">
      $1 has been added to your credit balance!
    </div>
  </div>
)

export const FriendCircles = ({
  friendsOrderCount,
  classNames,
  piggyBankSuccess
}) => (
  <Fragment>
    <YourLabel style={{ letterSpacing: '-1px' }} classNames={classNames} />{' '}
    <span className="piggyBankPlusEquals">+</span>
    {friendsOrderCount &&
      friendsOrderCount.slice(0, 5).map((friend, i) => (
        <div className="circleContainer" key={i}>
          <div className="labelOuter">
            <FriendLabel
              firstName={friend.firstName}
              lastName={friend.lastName}
              email={friend.email}
              showEmail={false}
              showName={false}
              classNames={{ piggybankColoredCircle: true }}
              size="small"
            />
          </div>
          <div className="creditsProgressBarShort creditsProgressBarColor" />
        </div>
      ))}
    {friendsOrderCount.length <= 5 &&
      [...Array(5 - friendsOrderCount.length)].map((x, i) => (
        <div className="circleContainer" key={i}>
          <div className="labelOuter">
            <div className="piggybankEmptyCircle" />
          </div>
          <div className="creditsProgressBarShort" />
        </div>
      ))}
    <div className="circleContainer">
      <span className="piggyBankPlusEquals">=</span>
      <span className="piggyBankDollar">$1.00</span>
      <div
        className={classnames({
          creditsProgressBarLong: true,
          rightRadius: true,
          creditsProgressBarColor: piggyBankSuccess
        })}
      />
    </div>
  </Fragment>
)

const PiggyBank = ({
  friendsOrderCount = [],
  orders,
  friends = [],
  activeOrders,
  hideOrderStatus,
  titleText,
  locationId
}) => {
  return (
    <div
      className={classnames({
        piggybankContainer: true,
        piggybankConfirmation: hideOrderStatus
      })}
    >
      {!hideOrderStatus && orders.length > 0 && (
        <Fragment>
          <OrderStatusSidebar locationId={locationId} />
          <hr />
        </Fragment>
      )}
      <div className="center-xs piggybankHeader">
        {titleText || 'Earn Credit Daily'}
      </div>
      {orders.length === 0 ||
      (orders.length > 0 && activeOrders.length === 0) ? (
        <OverFiveFriendsNoOrder
          {...{ friendsOrderCount, friendsCount: friends.length }}
        />
      ) : orders.find(order => order.isDelivered === true) &&
        friendsOrderCount.length >= 5 ? (
        <PiggyBankSuccess {...{ friendsOrderCount }} />
      ) : (
        orders.length > 0 && (
          <OverFiveFriendsWithOrder
            {...{ friendsOrderCount, friendsCount: friends.length }}
          />
        )
      )}
      {friends.length < 5 && (
        <UnderFiveFriends {...{ friendsCount: friends.length }} />
      )}
    </div>
  )
}

export default PiggyBank
